import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { extractAddress } from '../helper'
import TronWalletInfo from '../WalletInfo/TronWalletInfo';
import TronContext from '../../../../TronContext';

export default function TronWalletConfig({
  amount,
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {

  const { account, connectWallet, disconnectWallet } = useContext(TronContext);

  useEffect(() => {
    if (account) {
      setAddress(account);
    } else {
      setAddress("");
    }
  }, [account, setAddress])

  return (
    <div>
      <div className="title-block">
        <strong >
          {
            account ? `Wallet address ${extractAddress(account)}` : " Connect your wallet"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !account ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected a network and token. Click <b>Pay</b> to continue and connect your wallet via WalletConnect. This ensures a secure connection.
                  <br /><br />
                  After connecting, the payment will start automatically. Review and confirm the transaction in your wallet, and make sure you have enough balance and are on the correct network.
                </p>
              </div> :
              <div>
                <TronWalletInfo
                  amount={amount}
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={disconnectWallet}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}